export { default as StopAltOutlineIcon } from './StopAltOutlineIcon';
